import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Renders LLM markdown output with clean, tight typography. */
export default function Markdown({ children, className = "" }) {
  const text = typeof children === "string" ? children : "";
  if (!text.trim()) return null;
  return (
    <div className={`prose-md ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h1 className="text-xl font-semibold mt-4 mb-2" {...p}/>,
          h2: ({ node, ...p }) => <h2 className="text-lg font-semibold mt-4 mb-2" style={{ color: "var(--ink)" }} {...p}/>,
          h3: ({ node, ...p }) => <h3 className="text-base font-semibold mt-3 mb-1" {...p}/>,
          p:  ({ node, ...p }) => <p className="text-sm my-2" style={{ color: "var(--ink-2)" }} {...p}/>,
          ul: ({ node, ...p }) => <ul className="list-disc pl-5 space-y-1 my-2 text-sm" style={{ color: "var(--ink-2)" }} {...p}/>,
          ol: ({ node, ...p }) => <ol className="list-decimal pl-5 space-y-1 my-2 text-sm" style={{ color: "var(--ink-2)" }} {...p}/>,
          li: ({ node, ...p }) => <li className="leading-relaxed" {...p}/>,
          strong: ({ node, ...p }) => <strong style={{ color: "var(--ink)", fontWeight: 600 }} {...p}/>,
          em: ({ node, ...p }) => <em className="italic" {...p}/>,
          a:  ({ node, ...p }) => <a className="link-underline" style={{ color: "var(--accent)" }} target="_blank" rel="noreferrer" {...p}/>,
          code: ({ inline, node, ...p }) =>
            inline
              ? <code className="px-1.5 py-0.5 rounded text-xs" style={{ background: "var(--paper)", fontFamily: "JetBrains Mono, monospace" }} {...p}/>
              : <code className="block p-3 rounded-md text-xs overflow-auto" style={{ background: "var(--paper)", fontFamily: "JetBrains Mono, monospace" }} {...p}/>,
          hr: () => <hr className="my-4" style={{ borderColor: "var(--line)" }}/>,
          blockquote: ({ node, ...p }) => <blockquote className="pl-4 my-3 text-sm italic" style={{ borderLeft: "2px solid var(--accent)", color: "var(--ink-2)" }} {...p}/>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
